<template lang="html">
  <div class="col-lg-9 col-page-content page-comments">
    <div class="row">

      <div class="col-12">
        <div class="box-bubble">
          <div class="row">

            <div class="col-12 mb-0 box-acc-title-s1">
              <h4>Calificaciones a candidatos</h4>
              <hr />
            </div>

            <div class="col-12 box-average-rating">
              <div class="col col-txt">
                {{califications.length}} Calificaciones.
              </div>

              
            </div>

          </div>
        </div>

        <div class="mt-2 px-0 box-empty-bubble box-comments" v-if="califications.length == 0">
              <p>Aun no tienes calificaciones</p>
        </div>
        <div class="mt-2 px-0 box-empty-bubble box-comments" v-else>

          <div class="box-comment-sample-s1" v-for="(calification, indxc) in califications" :key="indxc">
            <div class="col col-photo">
              <div class="placed-backg img" v-bind:style="{ backgroundImage: 'url('+calification.imageUrlUser+')' }"></div>
            </div>

            <div class="col col-info">
              <div class="box-date">{{calification.creado}}</div>
              <h4>{{calification.user_name}}</h4>

              <div class="box-stars">
                <i class="fas fa-star star" v-for="(star, indst) in calification.calificacion" :key="indst"></i>

              </div>

              <div class="box-descr">
                {{calification.msg}}
              </div>
              	<a class="btn-profile"  target="_blank" :href="'https://jobusco.com/#/perfil-candidato/'+$root._converToURL(calification.user_name, calification.usuarios_id)">
                  <i class="far fa-eye icon"></i>
                  <span>Ver Perfil</span>
                </a>
              

              <div class="box-buttons">
                <a class="btn btn-cur-1 bg-red sm mr-sm-1" @click="deleteResponse(calification.id)">Borrar comentario</a>
               
              </div>
            </div>
          </div>

        </div>

      </div>

    </div>

    <!-- Modal - Responder -->
    <b-modal ref="modal-response" hide-footer no-close-on-backdrop no-close-on-esc centered size="lg" modal-class="modal-comment__user-account" title="Responder comentario">
      <div class="box-comment">
        <div class="box-comment-sample-s1">
          <div class="col col-photo">
            <div class="placed-backg img" v-bind:style="{ backgroundImage: 'url('+form.imageUrlUser+')' }"></div>
          </div>

          <div class="col col-info">
            <div class="box-date">{{form.creado}}</div>
              <h4>{{form.user_name}}</h4>

             <div class="box-stars">
                <i class="fas fa-star star" v-for="(star, indst) in form.calificacion" :key="indst"></i>

              </div>

            <div class="box-descr">{{form.msg}}</div>
          </div>
        </div>
      </div>

      <div class="box-response">
        <b-form-group>
          <b-form-textarea
            v-model="form.respuesta"
            placeholder="Tu respuesta como empresa"
            rows="4"
            max-rows="4"
            required
          ></b-form-textarea>
        </b-form-group>

        <div class="box-buttons">
          <b-button type="submit" class="btn-squ-cur-1 lg blue" @click="saveResponse">Responder comentario</b-button>
        </div>
      </div>
    </b-modal>
    <sweet-modal ref="modalLoading" hide-close-button blocking>

        <img src="/public/images/shared/loading.gif" width="30%">
        <p style="text-align: center;"><b>Cargando...</b></p>
    </sweet-modal>
    <sweet-modal ref="modalAlert" :icon="modal.icon">
          <p>{{modal.msg}}</p>
           <br><br>
          <a class="btn btn-info" @click="$refs.modalAlert.close()">Aceptar</a>
    </sweet-modal>
    <!--  -->

  </div>
</template>

<script>
export default {
  data(){
    return{
        form: {
          calificacion:null,
          creado:null,
          empresa_id: null,
          id:null,
          imageUrlUser:null,
          msg:null,
          user_name:null,
          usuarios_id:null,
          respuesta:null
        },
        calification_general:0,
        califications:[],
        modal:{
          icon:null,
          msg:null
      },
    }
  },

  methods: {
      
      deleteResponse(id){
      	axios.delete(tools.url("/api/admin/deleteResponseCalification/"+id)).then((response)=>{
              this.$root.auth();
              this.califications = this.$root.user.califications_candidates;
              this.$refs.modalLoading.close();
              this.modal.icon = 'success';
              this.modal.msg = 'Respuesta eliminada correctamente';
              this.$refs.modalAlert.open();


         }).catch((error)=>{
              this.$refs.modalLoading.close();
              this.modal.icon = 'error';
              this.modal.msg = 'Ocurrio un error al eliminar la información';
              this.$refs.modalAlert.open();

         });
      },
      
  },

  mounted(){
    this.calification_general = this.$root.user.calification_general;
    this.califications = this.$root.user.califications_candidates;
  }
}
</script>
